import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Breadcrumbs,
  BreadcrumbsItem,
  Card,
  Grid,
  GridItem,
  Button,
  Flex
} from "@sainsburys-tech/fable";
import DeviceEnergyChart from "../DeviceEnergyChart";
import NoDataMessage from "../NoDataMessage";
import SensorList from "../SensorList";
import DeviceTagList from "../DeviceTagList";
import BehindFeatureFlag from "../BehindFeatureFlag";
import * as Features from "../../utils/features";
import { KW, KWH } from "../../model/sensors/sensorReadingUnitKeys";
import moment from "moment";
import ExportSensorDataModal from "../ExportSensorDataModal";
import { Event } from "../Tracking";
import * as styles from "./DeviceDetailsPage.styles";

class DeviceDetailsPage extends Component {
  state = {
    initialValues: {
      exportFromDate: null,
      exportToDate: null,
      exportFromDateFocused: false,
      focusedInput: null
    },
    isValidExportDate: false,
    exportModalOpen: false,
    hasAPIError: false
  };

  setDateValidation = isValid => {
    this.setState({ isValidExportDate: isValid });
  };

  handleAPIError = () => {
    this.setState({ hasAPIError: true });
  };

  handleExportModalClose = () => {
    this.closeExportModal();
  };

  closeExportModal = () => {
    this.setState({
      exportModalOpen: false,
      sensorToExportData: null,
      isValidExportDate: false
    });
  };

  handleExportedData = () => {
    this.setState({ isValidExportDate: false });
    this.setState({
      initialValues: { exportFromDate: null, exportToDate: null }
    });
    Event(
      "Sensor Data Events",
      "Sensor Data Export",
      this.props.device.store.storeId
    );
  };

  render() {
    const isExportButtonVisible = this.props.device.sensors.some(
      sensor => sensor.unit.description === KWH
    );
    const sensors = this.props.device.sensors;
    const isEnabledBaseline = sensorId => {
      const sensor = this.props.device.sensors.find(item => {
        return item.sensorId === sensorId;
      });
      return (
        sensor &&
        sensor.calculateBaseline === true &&
        sensor.unit.description === KW
      );
    };
    return (
      <div>
        <Breadcrumbs>
          <BreadcrumbsItem style={styles.breadcrumbItem}>
            <Link to={{ pathname: `/stores/` }}>Stores</Link>
          </BreadcrumbsItem>
          <BreadcrumbsItem style={styles.breadcrumbItem}>
            <Link to={`/stores/${this.props.device.store.storeId}`}>
              {this.props.device.store.name}
            </Link>
          </BreadcrumbsItem>
          <BreadcrumbsItem style={styles.breadcrumbItemActive}>
            <Link to={{ pathname: `/devices/${this.props.device.deviceId}` }}>
              {this.props.device.name}
            </Link>
          </BreadcrumbsItem>
        </Breadcrumbs>
        <h3>{this.props.device.name}</h3>
        <div className="fable:pb-4">
          <Flex alignItems="start">
            <div style={{ flex: 1 }}>
              {this.props.device.tags && this.props.device.tags.length > 0 && (
                <DeviceTagList deviceTags={this.props.device.tags} />
              )}
            </div>
            <div>
              {this.props.sensorId && isEnabledBaseline(this.props.sensorId) && (
                <BehindFeatureFlag feature={Features.RESET_SENSOR_BASELINE}>
                  <Button variant="outlined">Reset baseline</Button>
                </BehindFeatureFlag>
              )}
            </div>
          </Flex>
        </div>
        {sensors.length === 0 ? (
          <NoDataMessage />
        ) : (
          <div style={{ backgroundColor: "#ffffff", padding: "20px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
            <Grid cols={1}>
              <GridItem colSpan={1}>
                <DeviceEnergyChart
                  sensors={sensors}
                  sensorId={this.props.sensorId}
                  onSensorChange={this.props.onSensorChange}
                  storeId={this.props.device.store.storeId}
                />
              </GridItem>
            </Grid>
          </div>
        )}
        <div className="fable:mb-4" />
        <h4>Sensor data</h4>
        {sensors.length === 0 ? (
          <NoDataMessage />
        ) : (
          <div style={{ backgroundColor: "#ffffff", padding: "20px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
            <SensorList
              sensors={this.props.device.sensors.map(s => ({
                ...s,
                lastValue: {
                  value:
                    s.latestSensorData != null ? s.latestSensorData.value : "",
                  time:
                    s.latestSensorData != null
                      ? moment(s.latestSensorData.time)
                      : ""
                }
              }))}
            />
            <Grid
              cols={{ xs: 5, sm: 3, md: 3, lg: 3, xl: 4 }}
              className={
                !isExportButtonVisible ? "cb-c-device_details_page__hidden" : ""
              }
            >
              <GridItem
                colSpan={1}
                className="fable:text-left"
              >
                <Button
                  variant="secondary"
                  isFullWidth
                  className="cb-c-device_details_page__export-sensor-data-btn"
                  onClick={() => this.setState({ exportModalOpen: true })}
                >
                  Export sensor data
                </Button>
              </GridItem>
            </Grid>
          </div>
        )}
        {isExportButtonVisible ? (
          <ExportSensorDataModal
            initialValues={this.state.initialValues}
            open={this.state.exportModalOpen}
            sensor={this.props.device.sensors.find(
              sensor => sensor.unit.description === KWH
            )}
            storeId={this.props.device.store.storeId}
            onClose={this.handleExportModalClose}
            onExportSuccess={this.handleExportedData}
            setDateValidation={this.setDateValidation}
            isValidDate={this.state.isValidExportDate}
            handleAPIError={this.handleAPIError}
            hasAPIError={this.state.hasAPIError}
          />
        ) : null}
      </div>
    );
  }
}

DeviceDetailsPage.propTypes = {
  device: PropTypes.object.isRequired,
  onSensorChange: PropTypes.func,
  sensorId: PropTypes.string
};

export default DeviceDetailsPage;
